export const getOptimizedImageUrl = (url, width = 800) => {
    if (!url) return '';

    // Si c'est une image locale (preview avant upload), on ne touche pas
    if (url.startsWith('blob:') || url.startsWith('data:')) return url;

    // Si l'URL n'est pas absolue, on ne touche pas
    if (!url.startsWith('http')) return url;

    // Solution Universelle (wsrv.nl)
    // Fonctionne pour Supabase Free Tier et tout autre hébergeur.
    // Redimensionne, compresse et convertit en WebP via un CDN global rapide.

    // On retire les params existants pour éviter les erreurs de double encodage
    const cleanUrl = url.split('?')[0];

    // Netty images are already optimized and some fail to load via the wsrv proxy
    if (cleanUrl.includes('netty.immo') || cleanUrl.includes('modelo')) {
        return cleanUrl;
    }

    // Decode to avoid double-encoding (like %2520 instead of %20)
    const fullyDecoded = decodeURI(cleanUrl);

    return `https://wsrv.nl/?url=${encodeURIComponent(fullyDecoded)}&w=${width}&q=80&output=webp`;
};
